export default __webpack_public_path__ + "static/media/cartbanner.89de9ced.jfif";